import { render, staticRenderFns } from "./GroupPaymentEdit.vue?vue&type=template&id=f20f4e4c"
import script from "./GroupPaymentEdit.vue?vue&type=script&lang=js"
export * from "./GroupPaymentEdit.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports